import { render, staticRenderFns } from "./GvdResources.vue?vue&type=template&id=a9b45564"
import script from "./GvdResources.vue?vue&type=script&lang=ts"
export * from "./GvdResources.vue?vue&type=script&lang=ts"
import style0 from "./GvdResources.vue?vue&type=style&index=0&id=a9b45564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports